import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import Modal from '../ui/Modal';
import useModal from '../../hooks/useModal'

const Card = ({ item, type }) => {
  const containerRef = useRef(null);
  const hasImages = item.images && item.images.length > 0;
  const [widthState, setWidthState] = useState('unknown');
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState();
  const [isFavorite, setIsFavorite] = useState(item.favorite);
  const backUrl = process.env.REACT_APP_API_URL;
  const [isToll] = useState(item.toll)

  
  useEffect(() => {
    const checkWidth = () => {
      const windowWidth = window.innerWidth;
      if (containerRef.current && hasImages) {
        let totalWidth = 0;
        const images = containerRef.current.querySelectorAll(".card__img img");
        images.forEach((image) => {
          const imageWidth = image.getBoundingClientRect().width;
          totalWidth += imageWidth; // 幅を加算
        });
        console.log(totalWidth)
        if (totalWidth <= windowWidth){
          if (images.length === 1) {
            setWidthState('wide')
          }else if(images.length === 2){
            setWidthState('medium')
          }
        }
      }
    };
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => {
      window.removeEventListener('resize', checkWidth);
    };
  }, []);


  const displayMap = {
    sharehouse:{
      type:"sharehouse",
      icon: <img src='/media/doller.svg' alt='money_icon' />,
      cat:`Rent $${item.rent}/w （Bond $${item.bond})`,
      circle:`${item.available}`,
      bottom_left:`Minimum ${item.minimum} weeks / `,
      bottom_right:`Notice ${item.notice} weeks`,
    },
    transaction:{
      type:"transaction",
      icon: <img src='/media/doller.svg' alt='money_icon' />,
      cat:`$${item.cost}`,
      circle: `${item.things_cat_name}`,
      bottom_left: item.maker_name
        ?`メーカー：${item.maker_name}　`
        :``,
      bottom_right: item.eileage_name
        ?`走行距離：${item.eileage_name}km`
        :``,
    },
    job:{
      type:"job",
      icon: <img src='/media/study.svg' alt='study_icon' />,
      cat:`必要英語力：${item.english_name}`,
      circle:`${item.job_cat_name}`,
      bottom_left: item.wages
        ?`時給 $${item.wages}~　`
        :``,
      bottom_right: item.wages2
        ?`(週末時給 $${item.wages2}~)`
        :``,
    },
  };

  const selectedDisplay = displayMap[type]

  const handleFavoriteClick = async (url, id, type) => {
    const token = localStorage.getItem('token');
    let model
    if (type === "sharehouse") {
      model = "Sharehouse"
    } else if (type === "transaction") {
      model = "Transaction"
    } else {
      model = "Job"
    }
    if (token){
      try {
        const response = await fetch(`${url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`, 
          },
          body: JSON.stringify({ model: model, post_id: id }),
        });
  
        if (response.ok) {
          const data = await response.json();
          setIsFavorite(!isFavorite);
          console.log('Favorite added:', data);
        } else {
          console.error('Failed to add favorite:', response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }else{
      setCurrentPage("404-login");
      openModal();
    }
  };
  
  return (
    <>
    <div className="card" ref={containerRef} style={{ backgroundColor: isToll? 'rgb(195 214 195)' : ''}}>
    {/* <div className="card" ref={containerRef} style={{ backgroundColor: isToll? 'rgb(232 217 200)' : ''}}> */}
      <a href={`/${selectedDisplay.type}/${item.id}`}>
      {hasImages && (
      <div className='card__img'>
          {item.images.map((image) => (
            <img key={image.id} src={image.image} alt={`${image.id}`}
              className={`${
                widthState === "wide"
                ? "wide" 
                :widthState === "medium"
                ? "medium"
                : ""
              }`}
            /> 
          ))}
      </div>
      )}
      <div className='card__content'>
        <div className='card__content-ttl'>
          <h4>{item.title}</h4>
          <p className='green'>{selectedDisplay.circle}</p>
          {isFavorite === false?(
            <div className='card__content-ttl-fav' id='outline' onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleFavoriteClick(`${backUrl}/api/favorites_get/`, item.id , type); }}>
              <FontAwesomeIcon icon={faStarRegular} />
            </div>
          ):(
            <div className='card__content-ttl-fav'id='color' onClick={(e) => {e.preventDefault(); e.stopPropagation();  handleFavoriteClick(`${backUrl}/api/delete_favorite/`, item.id , type);}}>
              <FontAwesomeIcon icon={faStarSolid} />
            </div>
          )
          }
        </div>
        <div className='card__content-section'>
          <div className='card__content-section'>
            <img src='/media/post-map.svg' alt='location-icon' />
            <span style={{ margin: '1px 5px' }}>{item.suburb}</span>
            </div>
          <div>
            {selectedDisplay.icon}
            <span style={{ margin: '1px 5px' }}>{selectedDisplay.cat}</span>
          </div>
          <div>
            <span style={{ margin: '1px 0' }}>
              {selectedDisplay.bottom_left}
              {selectedDisplay.bottom_right}
            </span>
          </div>
        </div>
        <p className='card__content-txt'>{item.content}</p>
      </div>
      {/* <img className='card__line' src='/media/line.svg' alt='card-line'/> */}
      </a>
    </div>
    <Modal isOpen={isOpen} closeModal={closeModal} currentPage={currentPage}  setCurrentPage={setCurrentPage} className="login">
    </Modal>
    </>
  );
};

export default Card;